<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12 px-gap">
          <div class="bg-white p-l-20 p-t-20 p-r-20 p-b-10 rounded shade" style="position: relative; max-height: 366px"
            data-v-step="4">
            <h5 class="no-margin" align="center">
              Data Tren Media Online
            </h5>
            <div v-if="data.display_tipe == 1 && !isloading" class="p-t-10 subscribe-overlay" align="center"
              style="height: 310px">
              <i class="bi bi-bar-chart-steps"></i>
              <p>
                Lihat perkembangan topik yang Anda monitor pada platform Media Berita Online.
              </p>
              <subscribe-btn />
            </div>
            <div class="p-t-10">
              <loader-component v-if="isloading" />
              <div v-else-if="!data.data_tren_formed" class="col-md-12 col-sm-12 col-lg-12">
                <div class="alert alert-danger mt-3" id="errorApiEl" role="alert" align="center">
                  <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                  Silahkan lakukan pencarian dengan parameter lain
                </div>
              </div>
              <line-chart-component v-else :series="data.data_tren_formed" :event="data.event_linechart_medkon"
                el="linechart-dashboard-mockup" mode="dual" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader_component from "@/views/components/loader.vue";
import line_chart from "@/views/components/chart/line_chart.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "medkon_tren_media_konvensional",
  components: {
    "loader-component": loader_component,
    "line-chart-component": line_chart,
  },
  props: {
    data: Object,
    isloading: Boolean,
  },
  filters: {
    number_format: function (number) {
      return gp.kmbFormatter(number);
    },
  },
};
</script>